module.exports = __webpack_public_path__ + "static/media/parents.a51fa241.png";